/**
 * Generated by orval 🍺
 * Do not edit manually.
 * eddy-be
 * API documentation of eddy-be
 * OpenAPI spec version: 3.4.15
 */

export type FeatureFlagStatus = typeof FeatureFlagStatus[keyof typeof FeatureFlagStatus];


export const FeatureFlagStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  IN_DEVELOPMENT: 'IN_DEVELOPMENT',
} as const;
